import {
  FETCH_TRAVEL_ORDER_LIST,
} from '../mutation-types'

const initialState = {
  travelOrderListData: [],
}

const mutations = {
  [FETCH_TRAVEL_ORDER_LIST](state, data) {
    state.travelOrderListData = data
  },
}

export default {
  state: initialState,
  mutations,
}



// WEBPACK FOOTER //
// ./client/vuex/modules/travelOrder.js